import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Sparkles } from 'lucide-react';
export function PricingBlock() {
  return <section id="pricing" className="pb-12" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#3D2B1F]/5" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-50">
          <div className="bg-[#FDF8F3] p-8 flex items-center justify-center relative overflow-hidden" data-id="element-51">
            <div className="absolute inset-0 bg-[#C4704B]/5" data-id="element-52" />
            <img src="https://cdn.magicpatterns.com/uploads/frB9EDju1PHFdJ4h48pADC/Foto_1.png" alt="El Fin de la Supermujer producto" className="relative z-10 w-full max-w-xs shadow-lg rounded-lg transform hover:scale-105 transition-transform duration-500" data-id="element-53" />
          </div>

          <div className="p-8 md:p-12 flex flex-col justify-center space-y-8 text-center md:text-left" data-id="element-54">
            <div data-id="element-55">
              <span className="inline-block px-4 py-1.5 bg-[#8B9E7E]/20 text-[#5A6B50] text-xs font-bold uppercase tracking-wider rounded-full mb-4" data-id="element-56">
                Oferta Especial
              </span>
              <h3 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] font-serif mb-2" data-id="element-57">
                Recupera tu paz mental
              </h3>
              <p className="text-[#3D2B1F]/70" data-id="element-58">
                Suelta la carga que te está envejeciendo hoy mismo.
              </p>
            </div>

            <div className="flex items-baseline justify-center md:justify-start space-x-3" data-id="element-59">
              <span className="text-2xl text-[#3D2B1F]/40 line-through font-medium" data-id="element-60">
                $27.00
              </span>
              <span className="text-5xl font-bold text-[#C4704B]" data-id="element-61">$6.39</span>
              <span className="text-[#3D2B1F]/50 font-medium" data-id="element-62">USD</span>
            </div>

            <div className="space-y-4" data-id="element-63">
              <motion.a href="https://multidigitalhub.com/cart/43612667904065:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02,
              boxShadow: '0 10px 25px -5px rgba(196, 112, 75, 0.4)'
            }} whileTap={{
              scale: 0.98
            }} animate={{
              boxShadow: ['0 0 0 0 rgba(196, 112, 75, 0)', '0 0 0 10px rgba(196, 112, 75, 0)']
            }} transition={{
              boxShadow: {
                repeat: Infinity,
                duration: 2
              }
            }} className="w-full bg-[#C4704B] text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg flex items-center justify-center space-x-2 hover:bg-[#B06040] transition-colors" data-id="element-64">
                <span data-id="element-65">QUIERO RECUPERAR MI PAZ AHORA</span>
                <Sparkles className="w-5 h-5" data-id="element-66" />
              </motion.a>

              <div className="flex items-center justify-center md:justify-start space-x-2 text-[#3D2B1F]/50 text-xs" data-id="element-67">
                <Lock className="w-3 h-3" data-id="element-68" />
                <span data-id="element-69">
                  Compra 100% segura. Acceso inmediato a tu transformación.
                </span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}